"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubAdminStrategyBuilder = void 0;
var react_1 = __importDefault(require("react"));
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var components_1 = require("../shared/components");
var StrategyReactFlow_1 = require("../shared/StrategyReactFlow");
var StructureEditor_1 = require("./components/StructureEditor");
var StrategyBeam_1 = require("./components/StrategyBeam");
var StrategyBuilderHeader_1 = require("./components/StrategyBuilderHeader");
var use_strategy_builder_state_1 = require("./hooks/use-strategy-builder-state");
var use_strategy_live_editing_1 = require("./hooks/use-strategy-live-editing");
var use_strategy_view_layout_1 = require("./hooks/use-strategy-view-layout");
require("./styles/strategy-builder.scss");
/**
 * WsAiHubAdminStrategyBuilder - AI Hub admin Strategy Builder tab.
 *
 * Pure orchestrator: composes {@link useStrategyBuilderState} (load/save +
 * draft tracking), {@link useStrategyLiveEditing} (presence) and
 * {@link useStrategyViewLayout} (responsive layout) and wires them into the
 * extracted UI components: {@link StrategyBuilderHeader}, {@link StrategyBeam},
 * {@link StructureEditor} and the read-only {@link StrategyReactFlow} preview.
 */
var WsAiHubAdminStrategyBuilder = function (props) {
    var _a, _b;
    // P3-1: validate the supplied user identity at the prop boundary. Without
    // an authenticated email we cannot safely emit live-editing presence or
    // attribute audit-log entries, so render an inline error instead of
    // continuing with a blank id. The hooks below run with the sanitized
    // value (or a sentinel) to keep the rules-of-hooks call order stable.
    var userEmail = ((_b = (_a = props.currentUser) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : '').trim().toLowerCase();
    var hasValidUser = userEmail.length > 0;
    var state = use_strategy_builder_state_1.useStrategyBuilderState(userEmail);
    var liveEditors = use_strategy_live_editing_1.useStrategyLiveEditing(state.selectedStrategyId, userEmail, state.hasUnsavedChanges).liveEditors;
    var _c = use_strategy_view_layout_1.useStrategyViewLayout(), viewLayout = _c.viewLayout, isViewLayoutLocked = _c.isViewLayoutLocked, setPreferredViewLayout = _c.setPreferredViewLayout;
    var _d = components_1.useConfirmDialog(), confirm = _d.confirm, confirmDialog = _d.dialog;
    var isAddingStrategy = state.strategyEditMode === 'add';
    var handleSelectStrategy = function (newStrategyId) { return __awaiter(void 0, void 0, void 0, function () {
        var ok;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(state.hasUnsavedChanges && newStrategyId !== state.selectedStrategyId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, confirm({
                            title: 'Discard unsaved changes?',
                            message: 'You have unsaved changes on the current strategy.',
                            subText: 'Do you want to continue and discard them?',
                            variant: 'error',
                            confirmText: 'Discard changes',
                        })];
                case 1:
                    ok = _a.sent();
                    if (!ok)
                        return [2 /*return*/];
                    _a.label = 2;
                case 2:
                    state.setSelectedStrategyId(newStrategyId);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleStartEditStrategy = function () {
        var selected = state.pendingStrategiesList.find(function (s) { return s.id === state.selectedStrategyId; });
        state.setStrategyNameInput(selected ? selected.name : '');
        state.setStrategyEditMode('edit');
    };
    var handleStartAddStrategy = function () {
        state.setStrategyNameInput('');
        state.setStrategyEditMode('add');
    };
    var handleConfirmStrategyEdit = function () {
        if (state.strategyEditMode === 'add') {
            state.addStrategy();
        }
        else {
            state.renameStrategy();
        }
    };
    var handleCancelStrategyEdit = function () {
        state.setStrategyEditMode(null);
        state.setStrategyNameInput('');
    };
    return (react_1.default.createElement("div", { className: "ws-strategy-builder-container" },
        !hasValidUser && (react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.error }, "Sign-in is required to use Strategy Builder.")),
        state.displayError && (react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.error, onDismiss: state.dismissError, dismissButtonAriaLabel: "Close" }, state.displayError)),
        react_1.default.createElement(StrategyBuilderHeader_1.StrategyBuilderHeader, { saveControls: {
                hasUnsavedChanges: state.hasUnsavedChanges,
                isSaving: state.isSaving,
                successMessage: state.successMessage,
                liveEditors: liveEditors,
                onSave: state.saveChanges,
                onDiscard: state.discardChanges,
                onDismissSuccess: state.dismissSuccess,
            }, viewLayoutToggle: {
                viewLayout: viewLayout,
                isLocked: isViewLayoutLocked,
                onChange: setPreferredViewLayout,
            } }),
        react_1.default.createElement("div", { className: "ws-strategy-layout ws-strategy-layout--" + viewLayout },
            react_1.default.createElement("div", { className: "ws-layout-controls" },
                react_1.default.createElement(StrategyBeam_1.StrategyBeam, { strategies: state.pendingStrategiesList, selectedStrategyId: state.selectedStrategyId, isLoading: state.isLoadingStrategies, isStrategyValid: state.isStrategyValid, hasLoadError: state.hasLoadError, editMode: state.strategyEditMode, nameInput: state.strategyNameInput, onSelectStrategy: handleSelectStrategy, onStartAdd: handleStartAddStrategy, onStartEdit: handleStartEditStrategy, onDelete: state.deleteStrategy, onConfirm: handleConfirmStrategyEdit, onCancelEdit: handleCancelStrategyEdit, onNameInputChange: state.setStrategyNameInput }),
                !isAddingStrategy && (react_1.default.createElement(StructureEditor_1.StructureEditor, { columns: state.columns, onColumnsChange: state.onColumnsChange, isLoading: state.isLoadingStrategies, hasStrategies: state.pendingStrategiesList.length > 0, hasStrategySelected: state.isStrategyValid }))),
            react_1.default.createElement("div", { className: "ws-layout-graph" },
                react_1.default.createElement("div", { className: "ws-visualization-sticky-container" },
                    react_1.default.createElement(StrategyReactFlow_1.StrategyReactFlow, { columns: state.selectedStrategyId ? state.debouncedColumns : [], isLoading: state.isLoadingStrategies || state.isVisualizationLoading || state.isSaving, fitViewTrigger: viewLayout })))),
        confirmDialog));
};
exports.WsAiHubAdminStrategyBuilder = WsAiHubAdminStrategyBuilder;
